import PropTypes from 'prop-types';
import React from 'react';
import { values } from 'lodash';
import SvgIcon from './SvgIcon';
import POSITION from '../../constants/pointerCursor';

const PointerCursor = (props) => {
    const positionClass = props.positionClass ? `point-${props.positionClass}` : '';

    return (
        <div className={`pointer-cursor-container ${positionClass}`}>
            <SvgIcon id="pointer" ariaLabelledBy="Cursor Pointer" class="lantern-svg" ariaDescribedBy="Cursor Pointer" />
            <span className={`pointer-cursor-click ${props.clicked ? ' ripple' : ''}`} />
        </div>
    );
};

PointerCursor.propTypes = {
    clicked: PropTypes.bool,
    positionClass: PropTypes.oneOf(values(POSITION)),
};

PointerCursor.defaultProps = {
    clicked: false,
    positionClass: undefined,
};

export default PointerCursor;
